import { MANTRA_ROLES, parseMantraRoles, canonicalMantraRoles } from './studioCalc.js';

export const CLASSIC_GROUPS = ['P', 'D', 'C', 'A'];

export const MANTRA_TO_CLASSIC = {
  P: 'P',
  DS: 'D', DC: 'D', DD: 'D', B: 'D',
  E: 'C', M: 'C', C: 'C', W: 'C', T: 'C',
  A: 'A', PC: 'A',
};

export function normalizePlayerRoles(playerOrRoles) {
  if (Array.isArray(playerOrRoles)) {
    return canonicalMantraRoles(playerOrRoles);
  }
  if (Array.isArray(playerOrRoles?.roles)) {
    return canonicalMantraRoles(playerOrRoles.roles);
  }
  return parseMantraRoles(playerOrRoles?.role || playerOrRoles || '');
}

export function mantraBucketsForPlayer(rolesInput) {
  const roles = normalizePlayerRoles(rolesInput);
  if (!roles.length) return [];
  if (roles.length === 1) return [roles[0]];
  return roles.map((r) => `${r}+`);
}

export function classicBucketsForPlayer(rolesInput) {
  const roles = normalizePlayerRoles(rolesInput);
  const set = new Set();
  for (const r of roles) {
    const g = MANTRA_TO_CLASSIC[r];
    if (g) set.add(g);
  }
  return CLASSIC_GROUPS.filter((g) => set.has(g));
}

export function allMantraBucketKeys() {
  return MANTRA_ROLES.flatMap((r) => [r, `${r}+`]);
}

export function bucketKind(key) {
  if (CLASSIC_GROUPS.includes(key) && !key.includes('+')) {
    // Classic keys overlap letter P/C/A with Mantra — callers pass mode
  }
  if (String(key).endsWith('+')) return 'plus';
  if (MANTRA_ROLES.includes(key)) return 'pure';
  if (CLASSIC_GROUPS.includes(key)) return 'classic';
  return 'unknown';
}
